import React from "react";
import {
  CustomOutlinedDisabledTextField,
  CustomOutlinedDisabledCurrencyField,
} from "../../../../../partials/content/Forms";
import { Card, Badge } from "react-bootstrap";
import { formatDate } from "../../../../../utils/utils";
import { FormOutlinedTextField } from "../../../../../partials/content/Forms/FormField";
import { InputAdornment } from "@material-ui/core";
import BootstrapTooltip from "../../../../../partials/content/BootstrapTooltip";
const AssetBasicInfo = ({ assetStock, batch }) => {
  return (
    <React.Fragment>
      <div className="row mb-3">
        <div className="col-sm-12 col-md-12 col-lg-12">
          <Card>
            <Card.Header>
              <i className="fas fa-window-maximize"></i>
              <span>
                <strong>Asset Header</strong>
              </span>
              <Badge
                className="float-right mx-2"
                variant={
                  assetStock.depreciationStatus === 3
                    ? "danger"
                    : assetStock.depreciationStatus === 2
                    ? "warning"
                    : assetStock.depreciationStatus === 1
                    ? "success"
                    : null
                }
              >
                {`Asset ${assetStock.depreciationStatusDesc}`}
              </Badge>
              <Badge
                className="float-right mx-2"
                variant={
                  assetStock.disposalStatus === 3
                    ? "danger"
                    : assetStock.disposalStatus === 2
                    ? "warning"
                    : assetStock.disposalStatus === 1
                    ? "success"
                    : null
                }
              >
                {`Asset ${assetStock.disposalStatusDesc}`}
              </Badge>
            </Card.Header>
            <Card.Body>
              <div className="row">
                <div className="col-sm-6 col-md-6 col-lg-6">
                  <FormOutlinedTextField
                    label="Asset Code"
                    value={assetStock.assetCode}
                    InputProps={{
                      startAdornment:
                        assetStock.itemType > 0 ? (
                          <InputAdornment position="start">
                            <BootstrapTooltip title={assetStock.itemTypeName}>
                              <i
                                className={
                                  assetStock.itemType === 1
                                    ? "fas fa-boxes text-success"
                                    : assetStock.itemType === 2
                                    ? "fas fa-tools text-primary"
                                    : assetStock.itemType === 3
                                    ? "fas fa-building text-info"
                                    : assetStock.itemType === 4
                                    ? "fas fa-boxes text-warning"
                                    : assetStock.itemType === 5
                                    ? "fas fa-boxes text-danger"
                                    : null
                                }
                              ></i>
                            </BootstrapTooltip>
                          </InputAdornment>
                        ) : null,
                      readOnly: true,
                    }}
                  />
                  <CustomOutlinedDisabledTextField
                    label="Asset Name"
                    value={assetStock.itemName}
                  />
                  <div className="row">
                    <div className="col-sm-6 col-md-6 col-lg-6">
                      <CustomOutlinedDisabledTextField
                        label="Purchase Date"
                        value={formatDate(assetStock.purchaseDate)}
                      />
                    </div>
                    <div className="col-sm-6 col-md-6 col-lg-6">
                      <CustomOutlinedDisabledTextField
                        label="Received Date"
                        value={formatDate(assetStock.receivedDate)}
                      />
                    </div>
                  </div>
                  {assetStock.assetOriginType === 1 ? (
                    <React.Fragment>
                      <CustomOutlinedDisabledTextField
                        label="Vendor Name"
                        value={assetStock.vendor.vendorName}
                      />
                    </React.Fragment>
                  ) : null}
                </div>
                <div className="col-sm-6 col-md-6 col-lg-6">
                  <CustomOutlinedDisabledTextField
                    label="Asset Origin"
                    value={assetStock.assetOriginTypeName}
                  />
                  <div className="row">
                    <div className="col-sm-6 col-md-6 col-lg-6">
                      <CustomOutlinedDisabledTextField
                        label="Quantity"
                        value={assetStock.qty}
                      />
                    </div>
                    <div className="col-sm-6 col-md-6 col-lg-6">
                      <CustomOutlinedDisabledTextField
                        label="Unit"
                        value={assetStock.uom.uomName}
                      />
                    </div>
                  </div>
                  {assetStock.assetOriginType === 1 ? (
                    <React.Fragment>
                      <div className="row">
                        <div className="col-sm-6 col-md-6 col-lg-6">
                          <CustomOutlinedDisabledCurrencyField
                            label="Purchase Unit Price"
                            value={batch.unitCost}
                          />
                        </div>
                        <div className="col-sm-6 col-md-6 col-lg-6">
                          <CustomOutlinedDisabledCurrencyField
                            label="Total Purchase Price"
                            value={batch.unitCost * assetStock.qty}
                          />
                        </div>
                      </div>
                    </React.Fragment>
                  ) : null}
                  {assetStock.assetOriginType === 1 ? (
                    <CustomOutlinedDisabledTextField
                      label="Cash Account"
                      value={assetStock.cashAccountName}
                    />
                  ) : (
                    <CustomOutlinedDisabledTextField
                      label="Income Account"
                      value={assetStock.incomeAccountName}
                    />
                  )}
                </div>
              </div>
              <div className="row">
                <div className="col-sm-12 col-md-12 col-lg-12">
                  <CustomOutlinedDisabledTextField
                    label="Asset Description"
                    value={assetStock.assetDesc}
                    multiline
                    minRows={2}
                  />
                </div>
              </div>
            </Card.Body>
          </Card>
        </div>
      </div>
      <div className="row">
        <div className="col-sm-6 col-md-6 col-lg-6 mb-3 mb-md-0">
          <Card>
            <Card.Header>
              <i className="fas fa-money-bill-wave"></i>
              <span>
                <strong>Asset Value</strong>
              </span>
            </Card.Header>
            <Card.Body>
              <div className="row">
                <div className="col-sm-12 col-md-12 col-lg-12">
                  <div className="row">
                    <div className="col-sm-6 col-md-6 col-lg-6">
                      <CustomOutlinedDisabledCurrencyField
                        label="Unit Asset Value"
                        value={assetStock.unitValueAmount}
                      />
                    </div>
                    <div className="col-sm-6 col-md-6 col-lg-6">
                      <CustomOutlinedDisabledCurrencyField
                        label="Total Asset Value"
                        value={assetStock.totalValueAmount}
                      />
                    </div>
                  </div>
                  <CustomOutlinedDisabledTextField
                    label="Cash Account"
                    value={assetStock.fixAssAccountName}
                  />
                </div>
              </div>
            </Card.Body>
          </Card>
        </div>
        <div className="col-sm-6 col-md-6 col-lg-6">
          <Card>
            <Card.Header>
              <i className="fas fa-money-bill-alt"></i>
              <span>
                <strong>Asset Depreciation</strong>
              </span>
            </Card.Header>
            <Card.Body>
              <div className="row">
                <div className="col-sm-12 col-md-12 col-lg-12">
                  <div className="row">
                    <div className="col-sm-6 col-md-6 col-lg-6">
                      <CustomOutlinedDisabledCurrencyField
                        label="Unit Depreciation Amount / Period"
                        value={assetStock.unitDepAmount}
                      />
                    </div>
                    <div className="col-sm-6 col-md-6 col-lg-6">
                      <CustomOutlinedDisabledCurrencyField
                        label="Total Depreciation Amount / Period"
                        value={assetStock.unitDepAmount * assetStock.qty}
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-6 col-md-6 col-lg-6">
                      <CustomOutlinedDisabledTextField
                        label="Accumulated Depreciation Account"
                        value={assetStock.accDepAccountName}
                      />
                    </div>
                    <div className="col-sm-6 col-md-6 col-lg-6">
                      <CustomOutlinedDisabledTextField
                        label="Depreciation Expense Account"
                        value={assetStock.depExAccountName}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </Card.Body>
          </Card>
        </div>
      </div>
    </React.Fragment>
  );
};

export default AssetBasicInfo;
